<script>

import Counter from './components/Counter.svelte';
import CountersGroup from './components/CountersGroup.svelte';
let allcounters = [
[{v:2},{v:1},{v:4}],
[{v:2},{v:4}],
[{v:2},{v:1},{v:4},{v:6}]
];
 let counterssum = 0 ;
</script>

<CountersGroup allcounters={allcounters} />

